<template>
  <div class="agent-property">
    <div class="title">{{$route.query.searchAccountPropertyType == 2 ? '個人放':'代理樓' }}盤數量列表</div>
    <div>
      <el-row>
        <el-col>
          <el-input class="w315" placeholder="樓盤編號、物業編號、放盤人、屋苑、地區" suffix-icon="el-icon-search" v-model="keyString"></el-input>
          <el-select class="w100" v-model="rentalType" no-data-text="暫無數據" placeholder="租售">
              <el-option label="全部" :value="0"></el-option>
              <el-option v-for="item in rentalList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
          </el-select>
          <el-select class="w150" v-model="categoryValue" placeholder="樓盤類型">
                <el-option class="property-tags-cascader-none-li" label="全部" value="0"></el-option>
                <el-cascader-panel
                    :key="isResouceShow"
                    v-model="category"
                    :options="categoryList"
                    :show-all-levels="false"
                    class="property-tags-cascader-panelcheckbox"
                    collapse-tags
                    ref="cascader"
                    :props="{
                        multiple: true,
                        children: 'children',
                        value: 'dictionaryValue',
                        label: 'dictionaryNameWithCulture',
                        checkStrictly: false
                    }"
                    clearable
                    @change="categoryCascaderChange"
                >
                </el-cascader-panel>
            </el-select>
            <el-select class="w150" v-model="zoneCode" placeholder="地區">
                <el-option v-for="(item, index) in regionList" :key="index" :label="item.gscopeNameWithCulture" :value="item.gscopeCode"></el-option>
            </el-select>
            <el-select class="w150" v-model="gscopeCode" no-data-text="暫無數據" placeholder="樓市片區">
                <el-option v-for="item in gscopeList" :key="item.gscopeCode" :label="item.gscopeNameWithCulture" :value="item.gscopeCode"></el-option>
            </el-select>
            <span class="btn-filter">
                <el-button type="danger" @click="clickSearch">搜尋</el-button>
                <el-button type="info" @click="resetSearch">重置</el-button>
                <el-button class="more" type="warning" @click="isMoreChoose = !isMoreChoose">打開更多選項</el-button>
            </span>
        </el-col>
        <div v-show="isMoreChoose"> 
          <el-col>
              <el-select class="w100" v-model="showStatus" placeholder="顯示狀態">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option v-for="item in showStatusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <el-select class="w150" v-model="saleRentStatus" placeholder="樓盤狀態">
                  <el-option v-if="statusList.length" label="全部" :value="0"></el-option>
                  <el-option v-for="item in statusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <el-select class="w150" v-model="isAdminOffLine" placeholder="已被下架">
                  <el-option v-for="item in isAdminOffList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <el-select class="w150" v-model="topType" placeholder="放盤方式">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option v-for="item in topOptions" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <el-select class="w160" style="width: 176px" multiple collapse-tags v-model="propertyLabelValueList" placeholder="功能">
                  <el-option v-for="item in propertyLabel" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <el-select class="w160" style="width: 176px" v-model="unitFloor" placeholder="樓層">
                  <el-option v-for="item in unitFloorList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
          </el-col>
          <el-col>
              <span class="area-span">租價範圍：</span>
              <el-select v-if="rentPriceCode !== 0 && !minRentPrice && !maxRentPrice" class="w160" v-model="rentPriceCode" placeholder="請選擇租價範圍">
                  <el-option label="自訂範圍" :value="0"></el-option>
                  <el-option v-for="item in rentPriceList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <div v-else class="input-model w245">
                  <el-input class="w90" v-model="minRentPrice" placeholder="請輸入價格" />
                  <span class="pm">-</span>
                  <el-input class="w90" v-model="maxRentPrice" placeholder="請輸入價格" />
                  <span class="pm">元</span>
              </div>
              <span class="area-span">售價範圍：</span>
              <el-select v-if="salePriceCode !== 0 && !minSalePrice && !maxSalePrice" class="w160" v-model="salePriceCode" placeholder="請選擇售價範圍">
                  <el-option label="自訂範圍" :value="0"></el-option>
                  <el-option v-for="item in salePriceList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <div v-else class="input-model w245">
                  <el-input class="w90" v-model="minSalePrice" placeholder="請輸入價格"></el-input>
                  <span class="pm">-</span>
                  <el-input class="w90" v-model="maxSalePrice" placeholder="請輸入價格"></el-input>
                  <span class="pm">萬</span>
              </div>
              <span class="area-span">建築面積：</span>
              <el-select class="w160" v-model="buildingAreaCode" placeholder="請選擇建築面積">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option v-for="item in areaList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
              <span class="area-span">實用面積：</span>
              <el-select class="w160" v-model="saleableAreaCode" placeholder="請選擇實用面積">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option v-for="item in areaList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
              </el-select>
          </el-col>
          <el-col>
              <span class="time">放盤時間：</span>
              <el-date-picker class="w150 mr4" format="yyyy/MM/dd" value-format="timestamp" v-model="publicTimeStartTime" :picker-options="publicTimeOption2" type="date" placeholder="選擇日期"></el-date-picker>-
              <el-date-picker class="w150" format="yyyy/MM/dd" value-format="timestamp" v-model="publicTimeEndTime" :picker-options="publicTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
              <span class="time">到期時間：</span>
              <el-date-picker class="w150 mr4" format="yyyy/MM/dd" value-format="timestamp" v-model="expireStartTime" :picker-options="expireTimeOption2" type="date" placeholder="選擇日期"></el-date-picker>-
              <el-date-picker class="w150" format="yyyy/MM/dd" value-format="timestamp" v-model="expireEndTime" :picker-options="expireTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
          </el-col>
        </div>
      </el-row>
    </div>
    <div class="table">
      <!-- 文字列表 -->
      <div class="text-list">
        <el-table
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
          :data="list"
          empty-text="暫無數據"
          style="width: 100%"
          v-loading="firstLoading"
        >
          <!-- 放盤人 -->
          <el-table-column label="放盤人" width="200">
            <template slot-scope="scope">
              <span class="account" v-if="scope.row.accountName">{{ scope.row.accountName }}</span>
              <span v-else>-</span>
              <div class="account">{{scope.row.departmentNameWithCulture}}</div>
            </template>
          </el-table-column>
          <!-- 楼盘編號 -->
          <el-table-column prop="propertyID" label="樓盤編號" width="100">
            <template slot-scope="scope">
              <!-- {{ scope.row.propertyID }} -->
              <span class="span">
                <el-button
                  class="btn-a"
                  @click="enterDetails(scope.row.rentalType,scope.row.propertyID)"
                  type="text"
                >{{ scope.row.propertyID }}</el-button>
              </span>
              <!-- <el-button @click="enter" type="text">{{ scope.row.propertyID }}</el-button> -->
            </template>
          </el-table-column>
          <!-- 物業編號 -->
          <el-table-column label="物業編號" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.propertyNo">{{ scope.row.propertyNo }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 放盤類型 -->
          <el-table-column label="放盤類型" width="100">
            <template slot-scope="scope">{{ scope.row.rentalTypeWithCulture }}</template>
          </el-table-column>
          <!-- 放盤方式 -->
          <el-table-column label="放盤方式" width="100">
            <template slot-scope="scope">{{ scope.row.topTypeWithCulture }}</template>
          </el-table-column>
          <!-- 圖片 -->
          <el-table-column label="圖片" width="100">
            <template slot-scope="scope">
              <!-- 图片 -->
              <img
                class="img-cover"
                :src="pub.imgResize(scope.row.imagePath, 'user')"
                onerror="errorImg(this,'property')"
                alt
              />
            </template>
          </el-table-column>
          <!-- 標題 -->
          <el-table-column label="標題" width="220">
            <template slot-scope="scope">
              <span v-if="scope.row.titleWithCulture">{{ scope.row.titleWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 區域 -->
          <el-table-column label="地區" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.zoneNameWithCulture">{{ scope.row.zoneNameWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 地區 -->
          <el-table-column label="樓市片區" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.gscopeNameWithCulture">{{ scope.row.gscopeNameWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 屋苑 -->
          <el-table-column label="屋苑" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.estateNameWithCulture">{{ scope.row.estateNameWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 期数 -->
          <el-table-column label="期數" width="180">
              <template slot-scope="scope">
                  <span v-if="scope.row.phase">{{ scope.row.phase }}</span>
                  <span v-else>-</span>
              </template>
          </el-table-column>
          <!-- 座數及單位 -->
          <el-table-column label="座數" width="100">
              <template slot-scope="scope">
                  <span v-if="scope.row.buildingName">{{ scope.row.buildingName }}</span>
                  <span v-else>-</span>
              </template>
          </el-table-column>
          
          <!-- 樓層 -->
          <el-table-column label="樓層" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.unitFloorWithCulture">{{ scope.row.unitFloorWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="單位" width="180">
              <template slot-scope="scope">
                  <span v-if="scope.row.roomNo">{{ scope.row.roomNo }}</span>
                  <span v-else>-</span>
              </template>
          </el-table-column>
          <!--分類  -->
          <el-table-column label="分類" width="100">
            <template slot-scope="scope">
              <span
                v-if="scope.row.propertyCategoryWithCulture"
              >{{ scope.row.propertyCategoryWithCulture }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 價格 -->
          <el-table-column label="售價(萬)" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.salePrice">
                {{
                parseInt(scope.row.salePrice / 10000)
                }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 組價 -->
          <el-table-column label="租價（元）" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.rentPrice">{{ scope.row.rentPrice}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 面積 -->
          <el-table-column label="面積" width="150">
            <template slot-scope="scope">
              <p>
                實用面積:
                {{ scope.row.saleableArea ? scope.row.saleableArea : "-" }}
              </p>
              <p>
                建築面積:
                {{ scope.row.buildingArea ? scope.row.buildingArea : "-" }}
              </p>
            </template>
          </el-table-column>
          <!-- 顯示狀態 -->
          <el-table-column label="顯示狀態" width="100">
            <template slot-scope="scope">{{ scope.row.isHide? "隱藏" : "顯示" }}</template>
          </el-table-column>
          <!-- 放盤狀態 -->
          <el-table-column label="放盤狀態" width="100">
            <template slot-scope="scope">{{ scope.row.propertyStatusWithCulture }}</template>
          </el-table-column>
          <!-- 樓盤詳情 -->
          <el-table-column label="樓盤詳情" width="200">
            <template slot-scope="scope">
              <p>更新時間:{{ scope.row.updateTime | getTime }}</p>
              <p>放盤時間:{{ scope.row.publicTime | getTime }}</p>
              <!-- <p>可重新置頂次數:{{ scope.row.recommendNumber }}</p> -->
              <p>可重新推前次數:{{scope.row.topType==0?'0': scope.row.recommendNumber }}</p>
            </template>
          </el-table-column>
          <el-table-column label="到期時間" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.expireTime > 0">
                <span
                  :class="{'red':expiredDate>=scope.row.expireTime}"
                >{{ scope.row.expireTime | getTime }}</span>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 圖片列表 -->
      <div class="footer">
        <el-pagination
          class="page"
          background
          @size-change="sizeChange"
          :page-size="pageCount"
          :page-sizes="[10, 20, 50, 100]"
          layout="total,sizes,prev, pager, next,jumper"
          @current-change="currentChange"
          :current-page="pageIndex"
          :total="count"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "agent",
  watch: {
        /**租售价修改监控 */
        rentPriceCode(val) {
            this.watchRentPrice(val);
        },
        minRentPrice(val) {
            this.watchRentPrice(val);
        },
        maxRentPrice(val) {
            this.watchRentPrice(val);
        },
        salePriceCode(val) {
            this.watchSalePrice(val);
        },
        minSalePrice(val) {
            this.watchSalePrice(val);
        },
        maxSalePrice(val) {
            this.watchSalePrice(val);
        },
        /**判断滚动距离 */
        scrollValue(val) {
            if (this.isMoreChoose) {
                if (val >= 250) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            } else {
                if (val >= 120) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            }
        },
        /**地區區域關聯 */
        zoneCode(val) {
            if (!val) this.gscopeList = [];
            this.gscopeCode = '';
            this.regionList.forEach(item => {
                if (item.gscopeCode === val) {
                    this.gscopeList = item.children;
                }
            });
        },
        /**暫時沒用 */
        editDepartmentID(val) {
            this.editAccountID = '';
            this.loadMarketParticipantsUser();
        },
        /**租售關聯 */
        rentalType(val) {
            if (val == 1) {
                this.statusList = this.SaleStatusList;
            } else if (val == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
        }
    },
    // computed: {
    //     ...mapGetters(['page', 'sideBar'])
    // },
  data() {
    return {
      isResouceShow: 1,
      isMoreChoose:false,
      keyString: '',
      rentalType: '',
      categoryValue: '',
      rentalList: [],
      category: '',
      categoryList: [],
      categoryValueEnd: [],

      categoryIf: [], 
      zoneCode: '',
      regionList: [],
      gscopeCode: '', 
      gscopeList: [],
      showStatus: '',
      showStatusList: [
        { dictionaryValue: 1, dictionaryNameWithCulture: '顯示' },
        { dictionaryValue: 2, dictionaryNameWithCulture: '隱藏' }
      ],
      saleRentStatus: '',
      statusList: [],
      isAdminOffLine: '',
      isAdminOffList: [],
      topType: '',
      topOptions: [],
      propertyLabelValueList: [],
      propertyLabel: [],
      unitFloor: '',
      unitFloorList: [],
      minBuildingArea: '',
      maxBuildingArea: '',
      minSaleableArea: '',
      maxSaleableArea: '',
      rentPriceCode: '',
      minRentPrice: '',
      maxRentPrice: '',
      salePriceCode: '',
      minSalePrice: '',
      maxSalePrice: '',
      salePriceList: [],
      rentPriceList: [],
      areaList: [],
      buildingAreaCode: '',
      saleableAreaCode: '',
      expireStartTime: '',
      expireEndTime: '',
      publicTimeStartTime: '',
      publicTimeEndTime: '',
      expireTimeOption: {
          disabledDate: this.expireTimeOption1
      },
      publicTimeOption: {
          disabledDate: this.publicTimeOption1
      },
      expireTimeOption2: {
          disabledDate: this.expireTimeOption3
      },
      publicTimeOption2: {
          disabledDate: this.publicTimeOption3
      },

      firstLoading: true,
      /**放盤類型 */
      pageIndex: 1,
      pageCount: 10,
      count: 0,
      accountID: "",
      searchAccountPropertyType: "",
      list: [],
      expiredDate: parseInt(
        (new Date().getTime() + 5 * 24 * 60 * 60 * 1000) / 1000
      )
    };
  },
  async created() {
    await this.pub.getDictionary().then(res => {
            this.categoryList = res.PropertyCategory.children;//
            this.isAdminOffList = res.isAdminOffLine.children;
            this.rentalList = res.RentalType.children;//
            /**去除置顶 */
            this.topOptions = res.TopOptions.children;
            this.AdRank = res.AdRank.children;
            this.SaleStatusList = res.SalePropertyStatus.children;
            this.RentStatusList = res.RentPropertyStatus.children;
            this.roomNumberList = res.RoomNumber.children;
            this.propertyLabel = res.PropertyLabel.children;
            this.salePriceList = res.SalePrice.children;
            this.rentPriceList = res.RentPrice.children;
            this.areaList = res.Area.children;
            this.propertyTagsList = res.PropertyTag.children;
            this.unitFloorList = res.UnitFloor.children;
            this.copyPropertyTags = res.PropertyTag.children;
            /**放盘状态判断 获取放盘状态列表 */
            if (this.rentalType == 1) {
                this.statusList = this.SaleStatusList;
            } else if (this.rentalType == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
        });

        let resgscope = await this.axios.get(this.pub.getApi().GetGscope);
        if (resgscope.data.code === 0 && resgscope.data.result) {
            this.regionList = [];
            resgscope.data.result.forEach(item => {
                item.children.forEach(i => {
                    this.regionList.push(i);
                });
            });
            if (this.zoneCode) {
                this.gscopeList = [];
                this.regionList.forEach(item => {
                    if (item.gscopeCode === this.zoneCode) {
                        this.gscopeList = item.children;
                    }
                });
            }
            /**获取片区值 */
            if (this.$route.params.gscopeCode) this.gscopeCode = this.$route.params.gscopeCode;
        }
    this.loadList(true);
    this.GetFullAgentCompany()

  },
  methods: {
    async GetFullAgentCompany(type) {
            const res = await this.axios.get(this.pub.getApi().GetFullAgentCompany);
            let { result } = res.data;
            const { data } = await this.axios.get(this.pub.getApi().SearchGscope);
            const list = data.result;
            const effect = list.find(item => {
                return item.children.find(el => {
                    return el.gscopeCode === result.gscopeCode;
                });
            });
            this.forms = result;
            this.gscopeList = effect.children;
            
        },
        categoryCascaderChange(val) {
            let that = this;
            let ConversData = [];
            // 是否与上次的类型相同
            let changeFlag = false;
            let changeItem = null;
            if (this.categoryValueEnd.length == 0) {
                this.category = val;
            } else {
                // 与原数组比对
                this.category.forEach(item => {
                    if (item[0] !== this.categoryValueEnd[0][0]) {
                        // 一级标签不同
                        changeFlag = true;
                        changeItem = item;
                        ConversData.push(item);
                    } else if ((!item[2] && this.categoryValueEnd[0][2]) || (item[2] && !this.categoryValueEnd[0][2])) {
                        changeFlag = true;
                        changeItem = item;
                        // console.log('二级标签不同');
                    }
                });
            }
            if (changeFlag) {
                this.category = [];
                this.category = ConversData;
            }
            function flatten(arr) {
                while (arr.some(item => Array.isArray(item))) {
                    //如果当前数组中还有数组，则展开
                    arr = [].concat(...arr);
                }
                return arr;
            }
            this.categoryValueEnd = this.category;
            let categoryValueEnd2 = flatten(this.category);
            this.categoryIf = [...new Set(categoryValueEnd2)];
            if (!this.category || !this.category.length) {
                this.categoryValue = '';
                return;
            }
            this.categoryValue = `樓盤類型(已選${this.category.length}個標籤)`;
        },
    /**监控价格改变 */
    watchRentPrice(val) {
            if (!val) return;
            this.rentalType = '2';
            this.salePriceCode = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
        },
        watchSalePrice(val) {
            if (!val) return;
            this.rentalType = '1';
            this.rentPriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
        },



    /**进入详情页 */
    enterDetails(type, id) {
      let url = `${this.pub.config.pcUrl}${
        type === 1 ? "buy" : "rent"
      }-property-${id}.html`;
      window.open(url);
    },
    // enter() {
    //   console.log("1");
    // },
    /**调整页面大小 */
    sizeChange(data) {
      this.pageCount = data;
      this.loadList();
    },
    /**數據翻頁 */
    currentChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.loadList();
    },
    /**获取列表 */
    loadList(first) {
      const data = this.getSearchValue();

      /**加载列表 接口调整*/
      this.axios
        .post(this.pub.getApi().SearchUserAgentPropertyByOrganization, data)
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            /**重置选择 */
            this.list = res.data.result.data;
            this.count = res.data.result.count;
            if (first) this.firstLoading = false;
          }
        });
    },
    resetSearch() {
            this.zoneCode = '';
            this.gscopeCode = '';
            this.estateName = '';
            this.rentalType = '';
            this.topType = '';
            this.showStatus = '';
            this.saleRentStatus = '';
            this.isAdminOffLine = '';
            this.unitFloor = '';
            this.expireStartTime = '';
            this.expireEndTime = '';
            this.publicTimeStartTime = '';
            this.publicTimeEndTime = '';
            this.accountName = '';
            this.roomNumber = '';
            this.category = '';
            this.categoryIf = '';
            this.keyString = '';
            this.paymentStatus = '';
            this.accountID = '';
            this.searchAccountPropertyType = '';
            this.buildingAreaCode = '';
            this.saleableAreaCode = '';
            this.SearchPropertyRemark = '';
            this.propertyLabelValueList = []
            this.rentPriceCode = '';
            this.salePriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
            this.propertyTags = [];
            this.propertyTagsValue = '';
            this.categoryValue = '';
            this.clickSearch();
            this.GetFullAgentCompany()
        },
          clickSearch() {
            this.pageIndex = 1;
            this.loadList();
        },
        
    /**获取搜索参数 */
    getSearchValue() {
      const data = {};
      if (this.$route.query.accountid)
        data.accountID = +this.$route.query.accountid;
        data.pageIndex = this.pageIndex;
        data.pageCount = this.pageCount;
        if (this.$route.query.searchAccountPropertyType) data.searchAccountPropertyType = this.$route.query.searchAccountPropertyType;
        if (this.gscopeCode) data.gscopeCode = this.gscopeCode;
        if (this.zoneCode) data.zoneCode = this.zoneCode;
        // 消息中心跳转置顶跳转的keystring是number类型
        if (typeof this.keyString == 'number') {
            this.keyString = String(this.keyString);
        }
        if (this.keyString) data.keyString = this.keyString.trim();
        if (this.paymentStatus) data.paymentStatus = this.paymentStatus;
        if (this.estateName) data.estateName = this.estateName;
        if (this.rentalType) data.rentalType = +this.rentalType;
        if (this.topType) data.topType = +this.topType;
        if (this.showStatus) data.isHide = this.showStatus - 1;
        if (this.saleRentStatus) data.propertyStatus = this.saleRentStatus;
        if (this.isAdminOffLine) data.isAdminOffLine = this.isAdminOffLine == 0 ? false : true;
        if (this.unitFloor) data.unitFloor = this.unitFloor;
        this.categoryList.forEach(item => {
            if (item.itemName == this.categoryIf[0]) {
                if (item.children != null) {
                    // 二级筛选
                    if (item.children.length != this.categoryIf.length - 1 && this.categoryIf.length > 1) data.SubCategory = this.categoryIf.slice(1);
                    // 一级分类
                    if (item.children.length == this.categoryIf.length - 1) data.category = this.categoryIf[0];
                } else {
                    data.category = this.categoryIf[0];
                }
            }
        });
        if (this.expireStartTime) data.expireStartTime = parseInt(this.expireStartTime / 1000);
        /**过期时间 */
        if (this.expireEndTime) {
            if (this.$route.params.due) data.expireEndTime = parseInt(this.expireEndTime / 1000);
            else data.expireEndTime = parseInt(this.expireEndTime / 1000 + 24 * 60 * 60);
        }
        if (this.publicTimeStartTime) data.publicTimeStartTime = parseInt(this.publicTimeStartTime / 1000);
        /**放盘时间 */
        if (this.publicTimeEndTime) {
            if (this.$route.params.due) data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000);
            else data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000 + 24 * 60 * 60);
        }
        /**是否VR */
        if (this.propertyLabelValueList && this.propertyLabelValueList.length) data.propertyLabelValueList = this.propertyLabelValueList;
        /**租售面积 */
        /**建筑实用面积 */
        if (this.buildingAreaCode) {
            data.minBuildingArea = this.buildingAreaCode.split('-')[0];
            data.maxBuildingArea = this.buildingAreaCode.split('-')[1];
        }
        if (this.saleableAreaCode) {
            data.minSaleableArea = this.saleableAreaCode.split('-')[0];
            data.maxSaleableArea = this.saleableAreaCode.split('-')[1];
        }

        /**租售价格*/
        if (this.rentPriceCode) {
            data.minRentPrice = this.rentPriceCode.split('-')[0];
            data.maxRentPrice = this.rentPriceCode.split('-')[1];
        }
        if (this.salePriceCode) {
            data.minSalePrice = this.salePriceCode.split('-')[0];
            data.maxSalePrice = this.salePriceCode.split('-')[1];
        }
        if (this.minRentPrice) data.minRentPrice = this.minRentPrice;
        if (this.maxRentPrice) data.maxRentPrice = this.maxRentPrice;
        if (this.minSalePrice) data.minSalePrice = this.minSalePrice * 10000;
        if (this.maxSalePrice) data.maxSalePrice = this.maxSalePrice * 10000;
        if (this.propertyTags) data.propertyTags = this.propertyTags;
        return data;
    },
    /**進入放盤 */
    post(index) {
      this.$router.push({
        path: "/property/post",
        query: {
          sequence: index
        }
      });
    }
  }
};
</script>

<style lang="less" >
.el-button--danger {
    background: #e50113;
}
.el-button--info {
    background: #bbbbbb;
    border: 1px solid #bbb;
}
.property-tags-cascader-panelcheckbox.el-cascader-panel.is-bordered {
          border: none;
          .el-scrollbar__view.el-cascader-menu__list {
            padding: 0;
          }
        }
        .property-tags-cascader-none-li {
          display: none;
        }
.agent-property {
        padding-bottom: 16px;  /* 按钮样式 */
        .el-button {
          height: 38px;
          width: 95px;
        }

        .btn-filter {
            padding-left: 10px;
            display: inline-block;
            padding-bottom: 16px;
            .more {
                background-color: #e1c999;
                border-color: #e1c999;
                color: #fff;
            }
            .more:active {
                background-color: #e6a23c;
                border-color: #e6a23c;
                color: #fff;
            }
        }

        input {
            color: #000;
            font-size: 14px;
            border: none;
            border-radius: 10px;
            height: 38px;
        }
        button {
            border-radius: 10px;
            // width: 88px;
            // height: 38px;
        }
        .w90,
        .w135,
        .w150,
        .w160,
        .w280,
        .w120,
        .w100,
        .w180,
        .w195,
        .w245,
        .w315 {
            margin-right: 15px;
            margin-bottom: 10px;
        }
        .mr4 {
            margin-right: 5px;
        }
        .w90 {
            width: 90px;
        }
        .w100 {
            width: 100px;
        }
        .w135 {
            width: 135px;
        }
        .w150 {
            width: 150px;
        }
        .w160 {
            width: 160px;
        }
        .w120 {
            width: 120px;
        }
        .w180 {
            width: 180px;
        }
        .w195 {
            width: 195px;
        }
        .w280 {
            width: 280px;
        }
        .w315 {
            width: 315px;
        }
        .w245 {
            width: 245px;
        }
        span.time {
            font-size: 14px;
            color: #666;
        }
        .self {
            background-color: #fff;
            border-radius: 10px;
            margin-bottom: 12px;
        }
        /**覆蓋樣式 */
        .more {
            width: 105px;
            padding: 12px 10px;
        }
        .input-model {
            box-sizing: border-box;
            display: inline-block;
            height: 38px;
            line-height: 38px;
            border-radius: 10px;
            padding: 0 8px;
            font-size: 14px;
            color: #333;
            .w90 {
                margin: 0;
            }
            .pm {
                margin: 0 6px;
            }
            /deep/ .el-input__inner {
                padding: 0 8px;
                line-height: 38px;
                height: 36px;
            }
        }
        .area-span {
            font-size: 14px;
            color: #666;
        }
  background-color: #f3f3f5;
  padding: 0;
  margin: 0;

  text-align: left;
  .title {
    padding: 0 0 20px 0;
    font-size: 24px;
    color: #171725;
  }
  .table {
    .btn-a {
      color: #0062ff;
    }
    margin-top: 28px;
    table,
    tr,
    td,
    th {
      border: none;
    }
    .el-table tbody tr:hover > td {
      background-color: rgba(80, 181, 255, 0.1) !important;
    }
    /deep/ .el-table thead tr {
      th:first-child {
        border-radius: 10px 0 0 10px;
      }
      th:nth-last-child(2) {
        border-radius: 0 10px 10px 0;
      }
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 38px;
    }
    .el-table th {
      border: none;
    }
    .el-table td {
      border-bottom: 1px solid #e2e2ea;
    }
    table {
      .el-button {
        text-align: left;
        width: 100%;
      }
      color: #222;
      font-size: 14px;
      tr th .cell {
        font-weight: normal;
        font-size: 12px;
        color: #44444f;
      }
    }
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
    .text-list {
      .account {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        line-height: 24px;
      }
      img {
        /**背景圖 */
        background-image: url("//static.house730.com/m/images/staff-default.png");
        background-size: 100% 100%;
        width: 50px;
        height: 50px;
        display: block;
      }
    }
    .footer {
      span {
        font-size: 14px;
        color: #44444f;

        margin-left: 16px;
      }
      margin-top: 16px;
      padding-top: 20px;
      box-sizing: border-box;
      height: 72px;
      .page {
        float: right;
      }
      .input-number {
        text-align: left;
        float: right;
        width: 70px;
      }
      /**覆盖计数器样式 */
      .el-input-number.is-controls-right .el-input__inner {
        padding-left: 8px;
        padding-right: 42px;
      }
    }
  }
}
</style>
